<section>
    <img src="assets/images/mturn_logo.png" alt="">
    <h3>{{'register.message1' | translate}} <b>mControl</b> {{'register.message2' | translate}}</h3>
    <span>{{token}}</span>
</section>
<h5>{{appVersion}}</h5>
